"use client";

import { useReducedMotion } from "framer-motion";
import { Reveal } from "../../home/motion";
import { Section, SectionHeading } from "../../home/section";
// Reuse the real product scene from the homepage use-case showcase. It is the
// sharpest boutique wedge: one intro-offer lead nurtured into a paying member
// automatically, while the studio is teaching. Rendered standalone here (no tab
// strip): plays once on scroll-in, then freezes (no onComplete).
import { ConvertTrials } from "../../home/use-case-tabs/scenes/intro-offer";

export function StudiosSpotlight() {
	const reduce = useReducedMotion() ?? false;

	return (
		<Section
			id="follow-up"
			className="border-t border-border bg-background"
			width="6xl"
		>
			<SectionHeading
				align="left"
				size="sm"
				eyebrow="Follow-up on autopilot"
				title={
					<>
						Watch an intro offer become a member.
						<span className="text-muted-foreground">
							{" "}
							Helios texts back, books the first class, and nudges at the right
							moments, automatically, so you convert trials without lifting a
							finger.
						</span>
					</>
				}
			/>

			<Reveal className="mt-10 lg:mt-14">
				<div className="overflow-hidden rounded-2xl border border-border bg-card shadow-xl lg:h-[36rem]">
					<ConvertTrials reduce={reduce} />
				</div>
			</Reveal>
		</Section>
	);
}
